import * as React from 'react'

import { SubMenu } from '../../../components/SubMenu/SubMenu'

interface Props {
  leftContent?: React.ReactNode
  rightContent?: React.ReactNode
}

export function QuoteStickySubMenu({ leftContent, rightContent }: Props) {
  return <SubMenu className="sticky z-30 sticky-22" leftContent={leftContent} rightContent={rightContent} />
}
